export const cities = [
  {
    id: "antalya",
    name: { tr: "Antalya", en: "Antalya", de: "Antalya", ru: "Анталия" },
  },
  {
    id: "belek",
    name: { tr: "Belek", en: "Belek", de: "Belek", ru: "Белек" },
  },
  {
    id: "side",
    name: { tr: "Side", en: "Side", de: "Side", ru: "Сиде" },
  },
  {
    id: "kizilagac",
    name: {
      tr: "Kızılağaç",
      en: "Kizilagac",
      de: "Kizilagac",
      ru: "Кызылагач",
    },
  },
  {
    id: "alanya",
    name: { tr: "Alanya", en: "Alanya", de: "Alanya", ru: "Аланья" },
  },
  { id: "kemer", name: { tr: "Kemer", en: "Kemer", de: "Kemer", ru: "Кемер" } },
  {
    id: "kas",
    name: { tr: "Kaş", en: "Kas", de: "Kas", ru: "Каш" },
  },
  {
    id: "kumluca",
    name: { tr: "Kumluca", en: "Kumluca", de: "Kumluca", ru: "Кумлука" },
  },
];

export const hotels = [
  // Antalya Hotels
  {
    id: 1001,
    city: "antalya",
    name: "Rixos Downtown Antalya",
    stars: 5,
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800",
    description: {
      tr: "Lüks deniz manzaralı otel",
      en: "Luxury sea view hotel",
      de: "Luxushotel mit Meerblick",
      ru: "Роскошный отель с видом на море",
    },
  },
  {
    id: 1002,
    city: "antalya",
    name: "Delphin Palace Hotel",
    stars: 5,

    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800",
    description: {
      tr: "Ultra herşey dahil resort",
      en: "Ultra all-inclusive resort",
      de: "Ultra-All-Inclusive-Resort",
      ru: "Ультра все включено курорт",
    },
  },
  {
    id: 1003,
    city: "antalya",
    name: "Titanic Beach Lara",
    stars: 5,

    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800",
    description: {
      tr: "Aile dostu lüks otel",
      en: "Family-friendly luxury hotel",
      de: "Familienfreundliches Luxushotel",
      ru: "Семейный роскошный отель",
    },
  },
  {
    id: 1004,
    city: "antalya",
    name: "Mardan Palace",
    stars: 5,

    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800",
    description: {
      tr: "Olağanüstü lüks deneyim",
      en: "Extraordinary luxury experience",
      de: "Außergewöhnliches Luxuserlebnis",
      ru: "Исключительный роскошный опыт",
    },
  },
  {
    id: 1005,
    city: "antalya",
    name: "Regnum Carya Golf Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1564501049412-61c2a3083791?w=800",
    description: {
      tr: "Golf ve spa konseptli otel",
      en: "Golf and spa concept hotel",
      de: "Golf- und Spa-Konzepthotel",
      ru: "Отель с гольфом и спа",
    },
  },
  {
    id: 1006,
    city: "antalya",
    name: "Akra Hotel",
    stars: 5,

    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800",
    description: {
      tr: "Modern şehir merkezi oteli",
      en: "Modern city center hotel",
      de: "Modernes Stadthotel",
      ru: "Современный отель в центре города",
    },
  },
  {
    id: 1007,
    city: "antalya",
    name: "Cornelia Diamond Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?w=800",
    description: {
      tr: "Premium aile tatili",
      en: "Premium family vacation",
      de: "Premium-Familienurlaub",
      ru: "Премиум семейный отдых",
    },
  },
  {
    id: 1008,
    city: "antalya",
    name: "Adam & Eve Hotel",
    stars: 5,

    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800",
    description: {
      tr: "Yetişkinlere özel ultra lüks",
      en: "Adults-only ultra luxury",
      de: "Nur für Erwachsene Ultra-Luxus",
      ru: "Ультра-люкс только для взрослых",
    },
  },
  {
    id: 1009,
    city: "antalya",
    name: "Kaya Palazzo Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1549294413-26f195200c16?w=800",
    description: {
      tr: "Benzersiz mimari ve konfor",
      en: "Unique architecture and comfort",
      de: "Einzigartige Architektur und Komfort",
      ru: "Уникальная архитектура и комфорт",
    },
  },
  {
    id: 1010,
    city: "antalya",
    name: "Voyage Belek Golf Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800",
    description: {
      tr: "Golf ve deniz bir arada",
      en: "Golf and sea combined",
      de: "Golf und Meer kombiniert",
      ru: "Гольф и море вместе",
    },
  },

  // Belek Hotels
  {
    id: 2001,
    city: "belek",
    name: "Four Seasons Sultanahmet",
    stars: 5,

    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?w=800",
    description: {
      tr: "Tarihi yarımada butik otel",
      en: "Historic peninsula boutique hotel",
      de: "Historisches Halbinsel-Boutique-Hotel",
      ru: "Бутик-отель на историческом полуострове",
    },
  },

  // Side Hotels
  {
    id: 3001,
    city: "side",
    name: "The Side Edition",
    stars: 5,

    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800",
    description: {
      tr: "Chic Side deneyimi",
      en: "Chic Side experience",
      de: "Schickes Side-Erlebnis",
      ru: "Шикарный опыт Сиде",
    },
  },

  // Kızılağaç Hotels
  {
    id: 4001,
    city: "kizilagac",
    name: "Swissotel Grand Efes",
    stars: 5,

    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800",
    description: {
      tr: "Şehir merkezinde konfor",
      en: "Comfort in city center",
      de: "Komfort im Stadtzentrum",
      ru: "Комфорт в центре города",
    },
  },

  // Alanya Hotels
  {
    id: 5001,
    city: "alanya",
    name: "Delphin Deluxe Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800",
    description: {
      tr: "Aile dostu tatil köyü",
      en: "Family-friendly resort",
      de: "Familienfreundliches Resort",
      ru: "Семейный курорт",
    },
  },

  // Kemer Hotels
  {
    id: 6001,
    city: "kemer",
    name: "Alaçatı Alantur",
    stars: 5,

    image: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800",
    description: {
      tr: "Alaçatı tarzı konaklama",
      en: "Alacati-style accommodation",
      de: "Unterkunft im Alacati-Stil",
      ru: "Размещение в стиле Алачати",
    },
  },

  // Kaş Hotels
  {
    id: 7001,
    city: "kas",
    name: "Hillside Beach Club",
    stars: 5,

    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800",
    description: {
      tr: "Butik lüks tatil köyü",
      en: "Boutique luxury resort",
      de: "Boutique-Luxus-Resort",
      ru: "Бутик-роскошный курорт",
    },
  },

  // Kumluca Hotels
  {
    id: 8001,
    city: "kumluca",
    name: "Delphin Deluxe Resort",
    stars: 5,

    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=800",
    description: {
      tr: "Herşey dahil lüks",
      en: "All-inclusive luxury",
      de: "All-Inclusive-Luxus",
      ru: "Роскошный все включено",
    },
  },
];

export const dubaiHotels = [
  {
    id: 101,
    name: "Burj Al Arab Jumeirah",
    website: "https://www.insideburjalarab.com/en",
    stars: 7,
    image: "/images/international/dubai_hotels/burj_al_arab_jumeirah.jpg",
    description: {
      tr: "Dünyanın en lüks oteli",
      en: "World's most luxurious hotel",
      de: "Das luxuriöseste Hotel der Welt",
      ru: "Самый роскошный отель в мире",
    },
  },
  {
    id: 102,
    name: "Atlantis The Palm",
    stars: 5,
    website: "https://www.atlantis.com/atlantis-the-palm",
    image: "/images/international/dubai_hotels/atlantis_the_palm.jpg",
    description: {
      tr: "Zarif sahil lüksü",
      en: "Elegant beachfront luxury",
      de: "Eleganter Luxus am Strand",
      ru: "Элегантная роскошь у моря",
    },
  },
  {
    id: 103,
    name: "Atlantis The Royal",
    stars: 5,
    website: "https://www.atlantis.com/atlantis-the-royal",
    image: "/images/international/dubai_hotels/atlantis_the_royal.jpg",
    description: {
      tr: "Ultra lüks deneyim",
      en: "Ultimate luxury experience",
      de: "Ultimativer Luxus­aufenthalt",
      ru: "Абсолютная роскошь",
    },
  },
  {
    id: 104,
    name: "Armani Hotel Dubai",
    stars: 5,
    website: "https://www.armanihotels.com/en/hotels/armani-hotel-dubai/",
    image: "/images/international/dubai_hotels/armani_hotel_dubai.jpg",
    description: {
      tr: "Moda imzasıyla şehir lüksü",
      en: "Fashion signature city luxury",
      de: "Mode-Ikone der Stadt",
      ru: "Модная икона городского стиля",
    },
  },
  {
    id: 105,
    name: "Jumeirah Beach Hotel",
    stars: 5,
    website: "https://www.jumeirah.com/en/stay/dubai/jumeirah-beach-hotel",
    image: "/images/international/dubai_hotels/jumeirah_beach_hotel.jpg",
    description: {
      tr: "Dalga formunda sahil oteli",
      en: "Wave-shaped beach hotel",
      de: "Wellenförmiges Strandhotel",
      ru: "Пляжный отель в форме волны",
    },
  },
  {
    id: 106,
    name: "The Lana, Dorchester Collection",
    stars: 5,
    website: "https://www.dorchestercollection.com/dubai/the-lana",
    image:
      "/images/international/dubai_hotels/the_lana_dorchester_collection.jpg",
    description: {
      tr: "Modern şehir zarafeti",
      en: "Refined waterfront luxury",
      de: "Elegante Ufer-Luxus",
      ru: "Современная городская элегантность",
    },
  },
  {
    id: 107,
    name: "Siro One Za’abeel",
    stars: 5,
    website: "https://www.sirohotels.com/dubai/one-zaabeel",
    image: "/images/international/dubai_hotels/siro_one_zaabeel.jpg",
    description: {
      tr: "Aktif yaşam & wellness oteli",
      en: "Active-lifestyle & wellness hotel",
      de: "Hotel für aktives Leben & Wellness",
      ru: "Отель для активной жизни и здоровья",
    },
  },
  {
    id: 108,
    name: "Jumeirah Emirates Towers",
    stars: 5,
    website: "https://www.jumeirah.com/en/stay/dubai/jumeirah-emirates-towers",
    image: "/images/international/dubai_hotels/jumeirah_emirates_towers.jpg",
    description: {
      tr: "Şehir merkezinde zarif iş oteli",
      en: "Elegant business hotel in the city centre",
      de: "Elegantes Business-Hotel im Stadtzentrum",
      ru: "Элегантный бизнес-отель в центре города",
    },
  },
  {
    id: 109,
    name: "Waldorf Astoria Dubai Palm Jumeirah",
    stars: 5,
    website:
      "https://www.hilton.com/en/hotels/dxbpdwa-waldorf-astoria-dubai-palm-jumeirah/",
    image:
      "/images/international/dubai_hotels/waldorf_astoria_dubai_palm_jumeirah.jpg",
    description: {
      tr: "Palm sahilinde zarif şıklık",
      en: "Elegant beachside luxury on Palm Jumeirah",
      de: "Eleganz am Strand von Palm Jumeirah",
      ru: "Элегантная роскошь у пляжа Палм Джумейра",
    },
  },
  {
    id: 110,
    name: "Le Royal Méridien Beach Resort & Spa",
    stars: 5,
    website:
      "https://www.marriott.com/en-us/hotels/dxbbm-le-royal-meridien-beach-resort-and-spa/overview/",
    image:
      "/images/international/dubai_hotels/le_royal_meridien_beach_resort_spa.jpg",
    description: {
      tr: "Tropikal sahil resortu",
      en: "Tropical beach resort",
      de: "Tropisches Strandresort",
      ru: "Тропический пляжный курорт",
    },
  },
  {
    id: 111,
    name: "Nikki Beach Resort & Spa Dubai",
    stars: 5,
    website: "https://nikkibeach.com/dubai/",
    image:
      "/images/international/dubai_hotels/nikki_beach_resort_spa_dubai.jpg",
    description: {
      tr: "Plajda parti ruhu ve tatil lüksü",
      en: "Beach-club vibe with luxury resort",
      de: "Strand-Party-Atmosphäre mit Luxusferien",
      ru: "Курорт класса люкс с пляжной клубной атмосферой",
    },
  },
  {
    id: 112,
    name: "Anantara The Palm Dubai Resort",
    stars: 5,
    website: "https://www.anantara.com/en/palm-dubai",
    image:
      "/images/international/dubai_hotels/anantara_the_palm_dubai_resort.jpg",
    description: {
      tr: "Tropikal tatil cenneti",
      en: "Tropical vacation paradise",
      de: "Tropisches Urlaubsparadies",
      ru: "Тропический рай для отдыха",
    },
  },
  {
    id: 113,
    name: "Taj Exotica Resort & Spa, The Palm Dubai",
    stars: 5,
    website: "https://www.exoticadubai.tajhotels.com/",
    image: "/images/international/dubai_hotels/taj_exotica_resort_spa.jpg",
    description: {
      tr: "Hint misafirperverliği ve lüks",
      en: "Indian hospitality and luxury",
      de: "Indische Gastfreundschaft und Luxus",
      ru: "Индийское гостеприимство и роскошь",
    },
  },
  {
    id: 114,
    name: "Four Seasons Hotel Dubai International Financial Centre",
    stars: 5,
    website: "https://www.fourseasons.com/dubaidifc/",
    image:
      "/images/international/dubai_hotels/four_seasons_hotel_dubai_international_financial_centre.jpg",
    description: {
      tr: "DIFC’de şehir oteli",
      en: "City hotel in DIFC",
      de: "Stadthotel im DIFC",
      ru: "Городской отель в DIFC",
    },
  },
  {
    id: 115,
    name: "Park Hyatt Dubai",
    stars: 5,
    website:
      "https://www.hyatt.com/en-US/hotel/united-arab-emirates/park-hyatt-dubai/dxbph",
    image: "/images/international/dubai_hotels/park_hyatt_dubai.jpg",
    description: {
      tr: "Körfez yanında zarafet",
      en: "Elegance by the creek",
      de: "Eleganz am Creek",
      ru: "Элегантность у рукава залива",
    },
  },
  {
    id: 116,
    name: "Raffles The Palm Dubai",
    stars: 5,
    website: "https://www.raffles.com/thepalm-dubai/",
    image: "/images/international/dubai_hotels/raffles_the_palm_dubai.jpg",
    description: {
      tr: "Palm Jumeirah’da ihtişam",
      en: "Grandeur on Palm Jumeirah",
      de: "Pracht auf der Palm Jumeirah",
      ru: "Великолепие на Пальме Джумейра",
    },
  },
  {
    id: 117,
    name: "Meliá Desert Palm Dubai",
    stars: 5,
    website:
      "https://www.melia.com/en/hotels/united-arab-emirates/dubai/hotel-desert-palm-melia-collection",
    image: "/images/international/dubai_hotels/melia_desert_palm_dubai.jpg",
    description: {
      tr: "Doğa içinde huzur",
      en: "Tranquility in nature",
      de: "Ruhe in der Natur",
      ru: "Уединение в природе",
    },
  },
  {
    id: 118,
    name: "Le Méridien Mina Seyahi Beach Resort & Waterpark",
    stars: 5,
    website:
      "https://www.marriott.com/en-us/hotels/dxbms-le-meridien-mina-seyahi-beach-resort-and-waterpark/overview/",
    image:
      "/images/international/dubai_hotels/le_meridien_mina_seyahi_beach_resort_waterpark.jpg",
    description: {
      tr: "Eğlenceli sahil ve su parkı",
      en: "Fun beachfront with waterpark",
      de: "Strandspaß mit Wasserpark",
      ru: "Весёлый пляж и аквапарк",
    },
  },
  {
    id: 119,
    name: "JW Marriott Hotel Marina Dubai",
    stars: 5,
    website:
      "https://www.marriott.com/en-us/hotels/dxbjm-jw-marriott-hotel-marina/overview/",
    image:
      "/images/international/dubai_hotels/jw_marriott_hotel_marina_dubai.jpg",
    description: {
      tr: "Dubai Marina’da şıklık",
      en: "Style in Dubai Marina",
      de: "Stil in der Dubai Marina",
      ru: "Стиль в Дубай Марина",
    },
  },
  {
    id: 120,
    name: "Le Méridien Dubai Airport Hotel",
    stars: 5,
    website:
      "https://www.marriott.com/en-us/hotels/dxbmd-le-meridien-dubai-hotel-and-conference-centre/overview/",
    image:
      "/images/international/dubai_hotels/le_meridien_dubai_airport_hotel.jpg",
    description: {
      tr: "Havaalanına yakın konfor",
      en: "Comfort close to the airport",
      de: "Komfort in Flughafennähe",
      ru: "Комфорт рядом с аэропортом",
    },
  },
];

export const dubaiTours = [
  {
    id: 201,
    name: {
      tr: "Premium Çöl Safarisi",
      en: "Premium Desert Safari",
      de: "Premium-Wüstensafari",
      ru: "Премиум сафари по пустыне",
    },
    description: {
      tr: "Lüks çöl deneyimi, gün batımı manzarası, deve gezisi, gurme akşam yemeği ve VIP hizmet.",
      en: "Luxury dune bashing, sunset views, camel rides, gourmet dinner, and VIP service in a private desert setting.",
      de: "Luxuriöses Dünenbashing, Sonnenuntergang, Kamelreiten, Gourmet-Abendessen und VIP-Service in privater Wüstenumgebung.",
      ru: "Роскошное катание по дюнам, закат, прогулки на верблюдах, ужин и VIP-обслуживание в частной пустыне.",
    },
    duration: "6 Saat / 6 Hours",
    price: 55,
    image: "/images/international/dubai_tours/dubai_desert_safari.jpg",
  },
  {
    id: 202,
    name: {
      tr: "Helikopter Turu",
      en: "Helicopter Tour",
      de: "Hubschrauberrundflug",
      ru: "Тур на вертолёте",
    },
    description: {
      tr: "Dubai'nin simge yapılarını havadan keşfedin, büyüleyici manzaralarla unutulmaz bir deneyim yaşayın.",
      en: "Fly over Dubai’s iconic landmarks for stunning aerial views and an unforgettable experience.",
      de: "Fliegen Sie über Dubais Wahrzeichen für atemberaubende Luftaufnahmen und ein unvergessliches Erlebnis.",
      ru: "Полёт над культовыми достопримечательностями Дубая и незабываемые виды с высоты.",
    },
    duration: "1 Saat / 1 Hour",
    price: 195,
    image: "/images/international/dubai_tours/dubai_helicopter_tour.jpg",
  },
  {
    id: 203,
    name: {
      tr: "Yat Turu (Özel)",
      en: "Yacht Tour (Private)",
      de: "Yacht-Tour (Privat)",
      ru: "Яхт-тур (частный)",
    },
    description: {
      tr: "15 kişilik özel yat turu. Saatlik ücretlendirme, alkolsüz içecekler dahil.",
      en: "Private yacht tour for up to 15 people. Charged by the hour. Soft drinks included.",
      de: "Private Yachttour für bis zu 15 Personen. Stündliche Abrechnung. Erfrischungsgetränke inklusive.",
      ru: "Частный яхт-тур до 15 человек. Оплата почасовая. Безалкогольные напитки включены.",
    },
    duration: "Saatlik / Hourly",
    price: 195,
    image: "/images/international/dubai_tours/dubai_yacht_turu.jpg",
  },
  {
    id: 204,
    name: {
      tr: "Burj Khalifa Giriş Bileti",
      en: "Burj Khalifa Entrance",
      de: "Burj Khalifa Eintritt",
      ru: "Вход в Бурдж-Халифа",
    },
    description: {
      tr: "Dünyanın en yüksek binasında 124. ve 125. kat gözlem teraslarına giriş.",
      en: "Entrance to 124th and 125th floor observation decks of the world’s tallest building.",
      de: "Eintritt zu den Aussichtsplattformen im 124. und 125. Stock des höchsten Gebäudes der Welt.",
      ru: "Вход на смотровые площадки 124 и 125 этажей самого высокого здания в мире.",
    },
    duration: "1.5 Saat / 1.5 Hours",
    price: 30,
    image: "/images/international/dubai_tours/dubai_burj_khalifa.jpg",
  },
  {
    id: 205,
    name: {
      tr: "The View at The Palm",
      en: "The View at The Palm",
      de: "Aussichtsplattform The View at The Palm",
      ru: "Обзорная площадка The View at The Palm",
    },
    description: {
      tr: "Palm Jumeirah'ın 52. katından muhteşem manzaralar. Cam terasta fotoğraf deneyimi.",
      en: "52nd floor Palm Island viewing experience with exhibition space and glass terrace photo spot.",
      de: "Aussichtserlebnis im 52. Stock der Palm Island mit Ausstellungsfläche und Glas-Terrasse.",
      ru: "Опыт на 52-м этаже Palm Jumeirah с выставочным пространством и стеклянной террасой для фото.",
    },
    duration: "2 Saat / 2 Hours",
    price: 50,
    image: "/images/international/dubai_tours/dubai_palm_view.jpg",
  },
  {
    id: 206,
    name: {
      tr: "Geleceğin Müzesi",
      en: "Museum of the Future",
      de: "Museum der Zukunft",
      ru: "Музей Будущего",
    },
    description: {
      tr: "Bilim, teknoloji ve hayal gücünün birleştiği etkileşimli sergilerle geleceği keşfedin.",
      en: "Dubai’s architectural marvel offering immersive exhibits blending science, technology, and imagination.",
      de: "Dubais architektonisches Wunder mit interaktiven Ausstellungen über Wissenschaft, Technologie und Vorstellungskraft.",
      ru: "Архитектурное чудо Дубая с интерактивными выставками, объединяющими науку, технологии и воображение.",
    },
    duration: "2 Saat / 2 Hours",
    price: 45,
    image: "/images/international/dubai_tours/dubai_future_museum.jpg",
  },
  {
    id: 207,
    name: {
      tr: "Safari Park",
      en: "Safari Park",
      de: "Safari Park",
      ru: "Сафари Парк",
    },
    description: {
      tr: "Açık hava safari deneyiminde 2500’den fazla hayvanı doğal ortamlarında keşfedin.",
      en: "Discover over 2,500 animals from around the world in an open-air safari experience.",
      de: "Entdecken Sie über 2.500 Tiere aus aller Welt in einem Open-Air-Safari-Erlebnis.",
      ru: "Откройте для себя более 2500 животных со всего мира на сафари под открытым небом.",
    },
    duration: "4 Saat / 4 Hours",
    price: 50,
    image: "/images/international/dubai_tours/dubai_safari.jpg",
  },
  {
    id: 208,
    name: {
      tr: "iFly Dubai (İç Mekan Skydiving)",
      en: "iFly Dubai (Indoor Skydiving)",
      de: "iFly Dubai (Indoor-Fallschirmspringen)",
      ru: "iFly Dubai (Прыжки в аэротрубе)",
    },
    description: {
      tr: "Güvenli rüzgar tünelinde yerçekimine meydan okuyun ve uçma hissini yaşayın.",
      en: "Experience the thrill of indoor skydiving at iFly Dubai in a state-of-the-art wind tunnel.",
      de: "Erleben Sie den Nervenkitzel des Indoor-Fallschirmspringens im hochmodernen Windkanal von iFly Dubai.",
      ru: "Испытайте восторг от полёта в аэротрубе iFly Dubai.",
    },
    duration: "1 Saat / 1 Hour",
    price: 15,
    image: "/images/international/dubai_tours/dubai_ifly.jpeg",
  },
  {
    id: 209,
    name: {
      tr: "The Green Planet",
      en: "The Green Planet",
      de: "The Green Planet",
      ru: "Зелёная планета",
    },
    description: {
      tr: "Dubai’nin tropik yağmur ormanı biyosferinde egzotik bitki ve hayvanları keşfedin.",
      en: "Dubai’s tropical rainforest bio-dome featuring exotic plants and animals.",
      de: "Dubais tropische Regenwald-Biodom mit exotischen Pflanzen und Tieren.",
      ru: "Тропический биокупол Дубая с экзотическими растениями и животными.",
    },
    duration: "2 Saat / 2 Hours",
    price: 45,
    image: "/images/international/dubai_tours/dubai_green_planet.jpg",
  },
  {
    id: 210,
    name: {
      tr: "Mucize Bahçesi (Miracle Garden)",
      en: "Miracle Garden",
      de: "Miracle Garden",
      ru: "Сад чудес (Miracle Garden)",
    },
    description: {
      tr: "Dünyanın en büyük çiçek bahçesinde milyonlarca çiçekle fotoğraf cenneti.",
      en: "Explore millions of vibrant flowers and stunning designs in the world’s largest flower garden.",
      de: "Erkunden Sie Millionen bunter Blumen und beeindruckender Designs im größten Blumengarten der Welt.",
      ru: "Исследуйте миллионы ярких цветов и потрясающих композиций в крупнейшем цветочном саду мира.",
    },
    duration: "3 Saat / 3 Hours",
    price: 17,
    image: "/images/international/dubai_tours/dubai_miracle_garden.jpg",
  },
  {
    id: 211,
    name: {
      tr: "Kelebek Bahçesi (Butterfly Garden)",
      en: "Butterfly Garden",
      de: "Schmetterlingsgarten",
      ru: "Сад бабочек",
    },
    description: {
      tr: "15.000'den fazla kelebeğin bulunduğu dünyanın en büyük iç mekan kelebek bahçesi.",
      en: "Explore the world’s largest indoor butterfly garden with over 15,000 butterflies in climate-controlled domes.",
      de: "Entdecken Sie den größten überdachten Schmetterlingsgarten der Welt mit über 15.000 Schmetterlingen.",
      ru: "Посетите крупнейший крытый сад бабочек с более чем 15 000 экземплярами.",
    },
    duration: "2 Saat / 2 Hours",
    price: 30,
    image: "/images/international/dubai_tours/dubai_butterfly_garden.jpg",
  },
  {
    id: 212,
    name: {
      tr: "Global Village",
      en: "Global Village",
      de: "Global Village",
      ru: "Глобал Вилладж",
    },
    description: {
      tr: "90’dan fazla ülkenin kültürünü, mutfağını ve gösterilerini tek bir yerde keşfedin.",
      en: "Explore cultures, cuisines, and shows from over 90 countries in one vibrant destination.",
      de: "Erleben Sie Kulturen, Küchen und Shows aus über 90 Ländern an einem lebendigen Ort.",
      ru: "Откройте для себя культуры, кухни и шоу более чем из 90 стран в одном месте.",
    },
    duration: "4 Saat / 4 Hours",
    price: 10,
    image: "/images/international/dubai_tours/dubai_global_village.jpg",
  },
  {
    id: 213,
    name: {
      tr: "Dubai Mall Akvaryumu",
      en: "Dubai Mall Aquarium",
      de: "Dubai Mall Aquarium",
      ru: "Аквариум в Dubai Mall",
    },
    description: {
      tr: "10 milyon litre su hacmiyle dünyanın en büyük akvaryumunda 33.000'den fazla deniz canlısını keşfedin.",
      en: "Discover over 33,000 aquatic species in the world’s biggest aquarium with 10 million liters of water.",
      de: "Entdecken Sie über 33.000 Meeresarten im größten Aquarium der Welt mit 10 Millionen Litern Wasser.",
      ru: "Исследуйте более 33 000 морских видов в крупнейшем аквариуме мира с объемом 10 миллионов литров воды.",
    },
    duration: "2 Saat / 2 Hours",
    price: 20,
    image: "/images/international/dubai_tours/dubai_mall_aquarium.jpg",
  },
  {
    id: 214,
    name: {
      tr: "The Lost Chambers Akvaryumu",
      en: "Lost Chambers Aquarium",
      de: "Lost Chambers Aquarium",
      ru: "Аквариум Lost Chambers",
    },
    description: {
      tr: "Atlantis’in kayıp şehrini su altı tünelleri ve 65.000 deniz canlısıyla keşfedin.",
      en: "Explore the lost city of Atlantis with underwater tunnels and over 65,000 marine animals.",
      de: "Erkunden Sie die verlorene Stadt Atlantis mit Unterwassertunneln und über 65.000 Meerestieren.",
      ru: "Исследуйте затерянный город Атлантиды с подводными тоннелями и более чем 65 000 морскими животными.",
    },
    duration: "2 Saat / 2 Hours",
    price: 55,
    image: "/images/international/dubai_tours/dubai_lost_chambers_aquarium.jpg",
  },
  {
    id: 215,
    name: {
      tr: "AYA Universe",
      en: "AYA Universe",
      de: "AYA Universe",
      ru: "AYA Universe",
    },
    description: {
      tr: "Işık, ses ve hayal gücüyle dolu 12 etkileşimli bölümüyle geleceğin dünyasına adım atın.",
      en: "Step into a futuristic world of light, sound, and imagination across 12 immersive zones.",
      de: "Tauchen Sie ein in eine futuristische Welt aus Licht, Klang und Fantasie mit 12 immersiven Zonen.",
      ru: "Погрузитесь в футуристический мир света, звука и воображения в 12 интерактивных зонах.",
    },
    duration: "2 Saat / 2 Hours",
    price: 37,
    image: "/images/international/dubai_tours/dubai_aya_universe.jpg",
  },
  {
    id: 216,
    name: {
      tr: "Sky View Gözlem Noktası",
      en: "Sky View Observatory",
      de: "Sky View Observatorium",
      ru: "Обсерватория Sky View",
    },
    description: {
      tr: "Modern mimarisiyle Dubai’nin 360° manzarasını cam köprü üzerinden izleyin.",
      en: "Enjoy 360-degree panoramic views of Dubai from a modern architectural observatory with a glass bridge.",
      de: "Genießen Sie 360°-Panoramablicke auf Dubai von einer modernen Aussichtsplattform mit Glasbrücke.",
      ru: "Насладитесь панорамным видом на Дубай с современной смотровой площадки со стеклянным мостом.",
    },
    duration: "1.5 Saat / 1.5 Hours",
    price: 60,
    image: "/images/international/dubai_tours/dubai_sky_view.jpg",
  },
  {
    id: 217,
    name: {
      tr: "La Perle by Dragone Gösterisi",
      en: "La Perle by Dragone Show",
      de: "La Perle by Dragone Show",
      ru: "Шоу La Perle by Dragone",
    },
    description: {
      tr: "Akrobatik, su gösterileri ve ışık efektleriyle dolu dünyaca ünlü Aqua Theatre deneyimi.",
      en: "Experience breathtaking acrobatics, water shows, and stunning visuals in Dubai’s world-renowned Aqua Theatre.",
      de: "Erleben Sie atemberaubende Akrobatik, Wassershows und visuelle Effekte im weltberühmten Aqua Theatre von Dubai.",
      ru: "Испытайте захватывающую акробатику и водное шоу в знаменитом Aqua Theatre Дубая.",
    },
    duration: "2 Saat / 2 Hours",
    price: 25,
    image: "/images/international/dubai_tours/dubai_la_perle_by_dragon.jpg",
  },
  {
    id: 218,
    name: {
      tr: "Burj Al Arab İç Turu",
      en: "Inside Burj Al Arab Tour",
      de: "Inside Burj Al Arab Tour",
      ru: "Тур Inside Burj Al Arab",
    },
    description: {
      tr: "Dubai'nin en ikonik otelinin lüks süitlerini ve tarihi detaylarını rehber eşliğinde keşfedin.",
      en: "Take a guided tour inside Dubai’s most iconic hotel and explore the luxurious Royal Suite with sea views.",
      de: "Machen Sie eine geführte Tour durch Dubais berühmtestes Hotel und besichtigen Sie die luxuriöse Royal Suite mit Meerblick.",
      ru: "Совершите экскурсию по самому культовому отелю Дубая и осмотрите роскошный Королевский люкс с видом на море.",
    },
    duration: "1.5 Saat / 1.5 Hours",
    price: 70,
    image: "/images/international/dubai_tours/dubai_burj_al_arab_tour.jpg",
  },
  {
    id: 219,
    name: {
      tr: "Jet Car Turu",
      en: "Jet Car Tour",
      de: "Jet-Car-Tour",
      ru: "Тур на Джет Каре",
    },
    description: {
      tr: "Dubai Marina'da su üstünde süper araba sürün! Benzersiz bir macera.",
      en: "Drive a supercar on water in Dubai Marina! A unique and thrilling experience.",
      de: "Fahren Sie ein Supersportauto auf dem Wasser in der Dubai Marina – ein einzigartiges Erlebnis.",
      ru: "Прокатитесь на водном суперкаре по Dubai Marina — уникальный захватывающий опыт.",
    },
    duration: "1 Saat / 1 Hour",
    price: 80,
    image: "/images/international/dubai_tours/dubai_jetcar.jpeg",
  },
  {
    id: 220,
    name: {
      tr: "Jet Ski Deneyimi",
      en: "Jet Ski Experience",
      de: "Jet Ski Erlebnis",
      ru: "Опыт на Jet Ski",
    },
    description: {
      tr: "Burj Al Arab ve Palm Jumeirah manzarası eşliğinde adrenalin dolu jet ski turu.",
      en: "Ride across the waves with stunning views of Burj Al Arab and Palm Jumeirah.",
      de: "Fahren Sie über die Wellen mit Blick auf Burj Al Arab und Palm Jumeirah.",
      ru: "Прокатитесь на гидроцикле с видом на Бурдж Аль Араб и Палм Джумейра.",
    },
    duration: "2 Saat / 2 Hours",
    price: 175,
    image: "/images/international/dubai_tours/dubai_jet_ski.jpg",
  },
  {
    id: 221,
    name: {
      tr: "Ski Dubai Kar Parkı",
      en: "Ski Dubai",
      de: "Ski Dubai",
      ru: "Ски Дубай",
    },
    description: {
      tr: "Dünyanın en büyük kapalı kar parkında kayak, snowboard ve penguenlerle buluşma.",
      en: "Ski, snowboard, and meet penguins in the world’s largest indoor snow park inside Mall of the Emirates.",
      de: "Skifahren, Snowboarden und Pinguine treffen im größten Indoor-Schneepark der Welt.",
      ru: "Катайтесь на лыжах, сноуборде и встречайте пингвинов в крупнейшем крытом снегопарке мира.",
    },
    duration: "3 Saat / 3 Hours",
    price: 65,
    image: "/images/international/dubai_tours/dubai_ski.jpg",
  },
  {
    id: 222,
    name: {
      tr: "Dinner in the Sky",
      en: "Dinner in the Sky",
      de: "Dinner in the Sky",
      ru: "Ужин в небесах",
    },
    description: {
      tr: "Dubai manzarasına karşı 50 metre yükseklikte gurme akşam yemeği deneyimi.",
      en: "Enjoy a gourmet meal 50 meters above ground with breathtaking views of Dubai’s skyline.",
      de: "Genießen Sie ein Gourmet-Abendessen 50 Meter über dem Boden mit atemberaubendem Blick auf Dubais Skyline.",
      ru: "Насладитесь ужином на высоте 50 метров с потрясающим видом на небоскрёб Дубая.",
    },
    duration: "2 Saat / 2 Hours",
    price: 215,
    image: "/images/international/dubai_tours/dubai_dinner_sky.jpg",
  },
  {
    id: 223,
    name: {
      tr: "Museum of Candy",
      en: "Museum of Candy",
      de: "Museum of Candy",
      ru: "Музей конфет",
    },
    description: {
      tr: "Renkli şeker temalı odalar, eğlenceli aktiviteler ve fotoğraf alanlarıyla dolu bir dünya.",
      en: "Step into a world of sweets with colorful candy-themed rooms, fun activities, and perfect photo spots.",
      de: "Tauchen Sie ein in eine Welt voller Süßigkeiten mit farbenfrohen Räumen und tollen Fotospots.",
      ru: "Погрузитесь в мир сладостей с красочными залами и веселыми фотозонами.",
    },
    duration: "2 Saat / 2 Hours",
    price: 35,
    image: "/images/international/dubai_tours/dubai_candy_museum.jpg",
  },
  {
    id: 224,
    name: {
      tr: "Bustronomi Dubai",
      en: "Bustronomi Dubai",
      de: "Bustronomi Dubai",
      ru: "Бастрономи Дубай",
    },
    description: {
      tr: "Panoramik manzaralı çift katlı otobüste gurme akşam yemeğiyle Dubai turu.",
      en: "Enjoy a fine dining experience on a double-decker bus while exploring Dubai’s top landmarks.",
      de: "Genießen Sie ein Gourmet-Dinner in einem Doppeldeckerbus und erkunden Sie Dubais Wahrzeichen.",
      ru: "Насладитесь ужином в двухэтажном автобусе, путешествуя по достопримечательностям Дубая.",
    },
    duration: "3 Saat / 3 Hours",
    price: 70,
    image: "/images/international/dubai_tours/dubai_bustronomi.jpg",
  },
];

export const dubaiTransfers = [
  {
    id: 301,
    name: {
      tr: "Havalimanı Transfer (Sedan)",
      en: "Airport Transfer (Sedan)",
      de: "Flughafentransfer (Limousine)",
      ru: "Трансфер из аэропорта (седан)",
    },

    capacity: 3,
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800",
  },
  {
    id: 302,
    name: {
      tr: "Havalimanı Transfer (SUV)",
      en: "Airport Transfer (SUV)",
      de: "Flughafentransfer (SUV)",
      ru: "Трансфер из аэропорта (внедорожник)",
    },

    capacity: 6,
    image: "https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800",
  },
  {
    id: 303,
    name: {
      tr: "VIP Transfer (Mercedes S-Class)",
      en: "VIP Transfer (Mercedes S-Class)",
      de: "VIP-Transfer (Mercedes S-Klasse)",
      ru: "VIP трансфер (Mercedes S-класс)",
    },

    capacity: 3,
    image: "https://images.unsplash.com/photo-1563720223185-11003d516935?w=800",
  },
  {
    id: 304,
    name: {
      tr: "Minivan Transfer",
      en: "Minivan Transfer",
      de: "Minivan-Transfer",
      ru: "Трансфер на минивэне",
    },

    capacity: 8,
    image: "https://images.unsplash.com/photo-1527786356703-4b100091cd2c?w=800",
  },
  {
    id: 305,
    name: {
      tr: "Luxury Van Transfer",
      en: "Luxury Van Transfer",
      de: "Luxus-Van-Transfer",
      ru: "Трансфер на роскошном фургоне",
    },

    capacity: 12,
    image: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800",
  },
];

export const dubaiVisa = {
  price: { tr: "450 TL", en: "$50", de: "45 €", ru: "4500 ₽" },
  duration: { tr: "30 Gün", en: "30 Days", de: "30 Tage", ru: "30 дней" },
  processing: {
    tr: "2-3 İş Günü",
    en: "2-3 Business Days",
    de: "2-3 Werktage",
    ru: "2-3 рабочих дня",
  },
  requirements: {
    tr: [
      "Pasaport fotokopisi",
      "Fotoğraf (beyaz fon)",
      "Otel rezervasyonu",
      "Uçak bileti",
    ],
    en: [
      "Passport copy",
      "Photo (white background)",
      "Hotel reservation",
      "Flight ticket",
    ],
    de: [
      "Passkopie",
      "Foto (weißer Hintergrund)",
      "Hotelreservierung",
      "Flugticket",
    ],
    ru: ["Копия паспорта", "Фото (белый фон)", "Бронь отеля", "Авиабилет"],
  },
};

export const services = [
  {
    id: 401,
    name: {
      tr: "Antalya Yat Turu",
      en: "Antalya Yacht Tour",
      de: "Antalya Yachttour",
      ru: "Анталья Яхт-тур",
    },

    image: "/images/services/antalya_yacht_tour.jpg",
    description: {
      tr: "Lüks iki katlı ve tek katlı yatlarımızla Antalya–Kemer-Belek-Side-Alanya sahillerinde şelale gezili  açık denizde yüzme keyfi sunan özel bir tur sizi bekliyor. Çocuklar için mini kulüp ve “her şey dahil” hizmetle gün boyu eğlence garantili yat turu organizasyonlarımız vardır .",
      en: " Private tour with luxury yacht offering swimming in open sea with waterfall visit along Antalya-Kemer-Belek-Side-Alanya coasts. Mini club for kids and all-inclusive service ensure a day full of fun.",
      de: "Private Tour mit Luxusyacht für Schwimmen im offenen Meer mit Wasserfallbesuch entlang der Küsten von Antalya-Kemer-Belek-Side-Alanya. Miniclub für Kinder und All-Inclusive-Service sorgen für einen Tag voller Spaß.",
      ru: "Частный тур на роскошной яхте с купанием в открытом море с посещением водопада вдоль побережья Анталья-Кемер-Белек-Сиде-Аланья. Мини-клуб для детей и обслуживание по системе «всё включено» гарантируют день, полный удовольствий.",
    },
  },
  {
    id: 402,
    name: {
      tr: "Antalya Şehir Turu",
      en: "Antalya City Tour",
      de: "Antalya Stadtrundfahrt",
      ru: "Анталья Городская экскурсия",
    },

    image: "/images/home/antalya_waterfall.jpg",
    description: {
      tr: "Konforlu üç katlı yat turumuzla Antalya’nın en güzel koylarını, Karpuzkaldıran Şelalesi’ni ve tarihi Kaleiçi’ni keşfedip keyifli bir Akdeniz günü yaşayabilirsiniz. Lezzetli öğle yemeği sonrası Antalya’nın büyük AVM’lerinde alışveriş imkânı da sunulmaktadır (içecekler ekstradır).",
      en: "Guided city tour exploring Antalya’s beautiful bays, Karpuzkaldıran Waterfall, and historic Kaleiçi with a comfortable three-deck yacht. Enjoy a delicious lunch followed by shopping opportunities at Antalya’s major malls (drinks are extra).",
      de: "Geführte Stadtrundfahrt zur Erkundung der schönen Buchten von Antalya, des Karpuzkaldıran-Wasserfalls und des historischen Kaleiçi mit einer komfortablen Dreideck-Yacht. Genießen Sie ein köstliches Mittagessen, gefolgt von Einkaufsmöglichkeiten in den großen Einkaufszentren von Antalya (Getränke sind extra).",
      ru: "Экскурсия по городу с гидом по красивым бухтам Антальи, водопаду Карпузкалдыран и историческому району Калейчи на комфортабельной трехпалубной яхте. Насладитесь вкусным обедом, а затем отправляйтесь за покупками в крупные торговые центры Антальи (напитки оплачиваются отдельно).",
    },
  },
  {
    id: 403,
    name: {
      tr: "İstanbul Şehir Turu",
      en: "Istanbul City Tour",
      de: "Istanbul Stadtrundfahrt",
      ru: "Стамбульская городская экскурсия",
    },

    image: "/images/services/istanbul_city_tour.jpg",
    description: {
      tr: "İstanbul turumuzda Ayasofya, Sultanahmet Camii ve Topkapı Sarayı gibi tarihi yerleri keşfederek şehrin büyüleyici tarihini yaşayabilirsiniz. Avrupa ve Asya’yı birleştiren Boğaz manzarasının keyfini çıkaracağınız bu turda İstanbul'un tarihini derinden hissedeceksiniz.",
      en: "Guided shopping mall tour exploring Istanbul's historic sites like Hagia Sophia, Blue Mosque, and Topkapi Palace. Enjoy the Bosphorus views that connect Europe and Asia while deeply experiencing Istanbul's rich history.",
      de: "Geführte Einkaufszentrum-Tour zur Erkundung der historischen Stätten Istanbuls wie Hagia Sophia, Blaue Moschee und Topkapi-Palast. Genießen Sie die Bosporus-Aussichten, die Europa und Asien verbinden, während Sie die reiche Geschichte Istanbuls tief erleben.",
      ru: "Экскурсия по торговому центру с гидом по историческим достопримечательностям Стамбула, таким как Айя-София, Голубая мечеть и дворец Топкапы. Насладитесь видами на Босфор, соединяющий Европу и Азию, глубоко погружаясь в богатую историю Стамбула.",
    },
  },
  {
    id: 404,
    name: {
      tr: "Manavgat Rafting",
      en: "Manavgat Rafting",
      de: "Manavgat Rafting",
      ru: "Рафтинг по Манавгату",
    },

    image: "/images/services/manavgat_rafting.jpg",
    description: {
      tr: "Deneyimli eğitmenler eşliğinde bot veya kano ile dağ nehrinde heyecan dolu rafting yaparken doğanın içinde unutulmaz anlar yaşayacaksınız. Açık havada öğle yemeği ve isteğe bağlı transfer ulaşım imkânı sunulmaktadır.",
      en: "Exciting rafting adventure with experienced instructors on mountain rivers using boats or canoes, offering unforgettable moments in nature. Outdoor lunch and optional transfer services are provided.",
      de: "Aufregendes Rafting-Abenteuer mit erfahrenen Trainern auf Bergflüssen mit Booten oder Kanus, das unvergessliche Momente in der Natur bietet. Im Freien Mittagessen und optionale Transferdienste werden angeboten.",
      ru: "Захватывающее приключение рафтинга с опытными инструкторами на горных реках с использованием лодок или каноэ, предлагающее незабываемые моменты на природе. Предоставляется обед на открытом воздухе и услуги трансфера по желанию.",
    },
  },
  {
    id: 405,
    name: {
      tr: "Helikopter Turu",
      en: "Helicopter Tour",
      de: "Hubschrauber-Tour",
      ru: "Вертолетная экскурсия",
    },

    image: "/images/services/helicopter_tour.jpg",
    description: {
      tr: "Antalya’yı helikopterle kuş bakışı keşfederek unutulmaz manzaralar eşliğinde harika fotoğraflar çekebilirsiniz. Dilerseniz Pamukkale, Kapadokya, Efes ve Demre gibi özel destinasyonlara da helikopterle VIP transfer ve tur imkânı sunuyoruz.",
      en: "Explore Antalya from a bird's-eye view by helicopter, capturing unforgettable scenes and stunning photos. We also offer VIP helicopter transfers and tours to special destinations like Pamukkale, Cappadocia, Ephesus, and Demre.",
      de: "Entdecken Sie Antalya aus der Vogelperspektive mit dem Hubschrauber und machen Sie unvergessliche Fotos. Wir bieten auch VIP-Hubschraubertransfers und Touren zu besonderen Zielen wie Pamukkale, Kappadokien, Ephesus und Demre an.",
      ru: "Исследуйте Анталью с высоты птичьего полета на вертолете, делая незабываемые снимки. Мы также предлагаем VIP-трансферы и туры на вертолете к таким особым направлениям, как Памуккале, Каппадокия, Эфес и Демре.",
    },
  },
  {
    id: 406,
    name: {
      tr: "VIP Transfer",
      en: "VIP Transfer",
      de: "VIP-Transfer",
      ru: "VIP трансфер",
    },

    image: "/images/services/vip_transfer.jpg",
    description: {
      tr: "Antalya’da her bölgede olmak üzere lüks araçlarımızla özel VIP transfer hizmeti sunmaktayız. Antalya'nın istediğiniz konumundan deneyimli şöförlerimiz ulaşmak istediğiniz konuma lüks araçlarımız ile ulaşımınızı sağlamaktadır. (Sprinter, Mercedes Vito, Mercedes S-Class, Mercedes E-Class)",
      en: "We offer private VIP transfer services with our luxury vehicles in every area of Antalya. Our experienced drivers will transport you from your desired location in Antalya to your destination in our luxury vehicles. (Sprinter, Mercedes Vito, Mercedes S-Class, Mercedes E-Class)",
      de: "Privater Transfer mit Luxusfahrzeug in jeder Region von Antalya. Unsere erfahrenen Fahrer bringen Sie von Ihrem gewünschten Standort in Antalya zu Ihrem Zielort mit unseren Luxusfahrzeugen. (Sprinter, Mercedes Vito, Mercedes S-Klasse, Mercedes E-Klasse)",
      ru: "Частный VIP трансфер на наших роскошных автомобилях в любом районе Антальи. Наши опытные водители доставят вас из желаемого места в Анталье до вашего пункта назначения на наших роскошных автомобилях. (Sprinter, Mercedes Vito, Mercedes S-Class, Mercedes E-Class)",
    },
  },
  {
    id: 407,
    name: {
      tr: "AVM Turu",
      en: "Mall Tour",
      de: "Einkaufszentrum-Tour",
      ru: "Экскурсия по торговому центру",
    },
    image: "/images/services/mall_tour.jpg",
    description: {
      tr: "The Land of Legends’ta heyecan dolu su kaydıraklarından Typhoon Coaster’a, yapay dalgalı dinlenme havuzlarına ve su altı safari deneyimine kadar onlarca eğlence sizi bekliyor. Günlük gösterilerde yunus ve foklarla buluşabileceğiniz bu dev temapark, ailece unutulmaz anlar sunuyor.",
      en: "Experience thrilling water slides, the Typhoon Coaster, wave pools, and underwater safari at The Land of Legends. Enjoy daily shows featuring dolphins and seals for unforgettable family moments.",
      de: "Erleben Sie aufregende Wasserrutschen, die Typhoon Coaster, Wellenbecken und Unterwassersafaris im The Land of Legends. Genießen Sie tägliche Shows mit Delfinen und Robben für unvergessliche Familienmomente.",
      ru: "Испытайте захватывающие водные горки, Typhoon Coaster, волновые бассейны и подводное сафари в The Land of Legends. Наслаждайтесь ежедневными шоу с дельфинами и тюленями для незабываемых семейных моментов.",
    },
  },
  {
    id: 408,
    name: {
      tr: "Pamukkale Turu",
      en: "Pamukkale Tour",
      de: "Pamukkale Tour",
      ru: "Тур в Памуккале",
    },
    image: "/images/services/pamukkale_tour.jpg",
    description: {
      tr: "Pamukkale’nin dünyada eşi olmayan bembeyaz travertenlerinde yürüyüp, 36°C sıcaklıktaki ünlü Kleopatra Havuzu’nda yüzerek benzersiz bir termal deneyim yaşayabilirsiniz. Hierapolis antik kenti, Apollon Tapınağı ve büyük nekropol ile bu tur tarih ve doğayı bir araya getiriyor (Kleopatra Havuzu ve içecekler ekstradır).",
      en: "Walk on the unique white travertines of Pamukkale and enjoy a thermal experience by swimming in the famous Cleopatra Pool with a temperature of 36°C. This tour combines history and nature with the ancient city of Hierapolis, the Temple of Apollo, and the large necropolis (Cleopatra Pool and drinks are extra).",
      de: "Spazieren Sie auf den einzigartigen weißen Travertinen von Pamukkale und genießen Sie ein Thermalbad im berühmten Kleopatra-Pool mit einer Temperatur von 36°C. Diese Tour verbindet Geschichte und Natur mit der antiken Stadt Hierapolis, dem Apollon-Tempel und dem großen Nekropol (Kleopatra-Pool und Getränke sind extra).",
      ru: "Прогуляйтесь по уникальным белым травертинам Памуккале и насладитесь термальным опытом, купаясь в знаменитом бассейне Клеопатры с температурой 36°C. Этот тур сочетает в себе историю и природу с древним городом Иераполис, храмом Аполлона и большим некрополем (бассейн Клеопатры и напитки оплачиваются отдельно).",
    },
  },
  {
    id: 409,
    name: {
      tr: "Antalya Akvaryum Turu",
      en: "Antalya Aquarium Tour",
      de: "Antalya Aquarium Tour",
      ru: "Тур в аквариум Антальи",
    },
    image: "/images/services/antalya_aquarium.jpg",
    description: {
      tr: "Antalya Aquarium’da birbirinden özel 40 tematik akvaryumu ve dünyanın en büyük su altı tünelini keşfederek büyüleyici bir okyanus deneyimi yaşayabilirsiniz. Dilerseniz “Snow World” bölümünde gerçek kar ve buz heykelleriyle dolu eğlenceli bir atmosferi de deneyimleyebilirsiniz.",
      en: "Explore 40 unique thematic aquariums and the world's largest underwater tunnel at Antalya Aquarium for a captivating ocean experience. Optionally, enjoy the fun atmosphere of the 'Snow World' section filled with real snow and ice sculptures.",
      de: "Entdecken Sie 40 einzigartige thematische Aquarien und den größten Unterwassertunnel der Welt im Antalya Aquarium für ein faszinierendes Ozeanerlebnis. Optional können Sie den unterhaltsamen Bereich 'Snow World' mit echtem Schnee und Eisskulpturen genießen.",
      ru: "Исследуйте 40 уникальных тематических аквариумов и самый большой подводный туннель в мире в аквариуме Антальи для захватывающего океанического опыта. По желанию, насладитесь веселой атмосферой раздела 'Snow World', наполненного настоящим снегом и ледяными скульптурами.",
    },
  },
  {
    id: 410,
    name: {
      tr: "Antalya Teleferik",
      en: "Antalya Cable Car",
      de: "Antalya Seilbahn",
      ru: "Канатная дорога Антальи",
    },
    image: "/images/services/antalya_cable_car.jpg",
    description: {
      tr: "2365 metre yüksekliğe çıkan Tahtalı Teleferiği ile Antalya sahilinin en etkileyici manzaralarını yukarıdan keşfedebilirsiniz. Adrenalin sevenler için, dünya rekoru yüksekliğe sahip Tahtalı Dağı’ndan pilot eşliğinde yamaç paraşütü uçuşu da sunuyoruz.",
      en: "Discover breathtaking views of Antalya's coastline from above with the Tahtali Cable Car, which ascends to 2365 meters. For adrenaline enthusiasts, we also offer tandem paragliding flights from Tahtali Mountain, which holds a world record for height.",
      de: "Entdecken Sie atemberaubende Ausblicke auf die Küste von Antalya von oben mit der Tahtali-Seilbahn, die auf 2365 Meter hinaufführt. Für Adrenalinliebhaber bieten wir auch Tandem-Gleitschirmflüge vom Tahtali-Berg an, der einen Weltrekord für Höhe hält.",
      ru: "Откройте для себя захватывающие виды на побережье Антальи с высоты с помощью канатной дороги Таhtali, которая поднимается на 2365 метров. Для любителей адреналина мы также предлагаем полеты на параплане в тандеме с горы Таhtali, которая держит мировой рекорд по высоте.",
    },
  },
  {
    id: 411,
    name: {
      tr: "Kapadokya Turu",
      en: "Cappadocia Tour",
      de: "Kappadokien Tour",
      ru: "Тур по Каппадокии",
    },
    image: "/images/services/cappadocia_tour.jpg",
    description: {
      tr: "Kapadokya’da milyonlarca yılda oluşan peri bacaları, yeraltı şehirleri ve kayaya oyulmuş kiliselerle masalsı bir atmosferi keşfedeceksiniz. Bu tur, Anadolu’nun tarihini ve kültürünü en etkileyici haliyle görme fırsatı sunar (içecekler ekstradır). Dilerseniz Kapadokya’nın tarihi taştan otellerinde konaklamalı turlarımızda vardır.",
      en: "Discover the fairy chimneys, underground cities, and rock-carved churches of Cappadocia, formed over millions of years, creating a magical atmosphere. This tour offers a unique opportunity to experience the history and culture of Anatolia (drinks are extra). We also offer tours with accommodation in Cappadocia's historic stone hotels.",
      de: "Entdecken Sie die Feenkamine, unterirdischen Städte und in Felsen gehauenen Kirchen Kappadokiens, die sich über Millionen von Jahren gebildet haben und eine magische Atmosphäre schaffen. Diese Tour bietet eine einzigartige Gelegenheit, die Geschichte und Kultur Anatoliens zu erleben (Getränke sind extra). Wir bieten auch Touren mit Unterkunft in den historischen Steinhotels Kappadokiens an.",
      ru: "Откройте для себя волшебные дымоходы, подземные города и церкви, вырезанные в скалах Каппадокии, образовавшиеся за миллионы лет, создавая волшебную атмосферу. Этот тур предлагает уникальную возможность познакомиться с историей и культурой Анатолии (напитки оплачиваются отдельно). Мы также предлагаем туры с проживанием в исторических каменных отелях Каппадокии.",
    },
  },
  {
    id: 412,
    name: {
      tr: "Aspendos Side Antik Kent Turu",
      en: "Aspendos Side Ancient City Tour",
      de: "Aspendos Side Antike Stadt Tour",
      ru: "Тур по древнему городу Аспендос Сиде",
    },
    image: "/images/home/antalya_manavgat.jpg",
    description: {
      tr: "Efes Antik Kenti, Neolitik Çağ’a uzanan geçmişi ve Artemis Tapınağı, Herakleitos gibi ünlü düşünürlere ev sahipliği yapan zengin kültürel mirasıyla Ege’nin en etkileyici tarihi duraklarından biridir. Bu turda, antik dünyanın bilim, sanat ve ticaret merkezlerinden biri olan Efes’i tüm ihtişamıyla keşfedeceksiniz.",
      en: "Explore the historical cities of Aspendos and Side, renowned for their well-preserved Roman theaters, ancient ruins, and rich cultural heritage. This tour offers a deep dive into the fascinating history and architecture of these ancient cities along the Mediterranean coast.",
      de: "Erkunden Sie die historischen Städte Aspendos und Side, die für ihre gut erhaltenen römischen Theater, antiken Ruinen und ihr reiches kulturelles Erbe bekannt sind. Diese Tour bietet einen tiefen Einblick in die faszinierende Geschichte und Architektur dieser antiken Städte entlang der Mittelmeerküste.",
      ru: "Исследуйте исторические города Аспендос и Сиде, известные своими хорошо сохранившимися римскими театрами, древними руинами и богатым культурным наследием. Этот тур предлагает глубокое погружение в увлекательную историю и архитектуру этих древних городов вдоль побережья Средиземного моря.",
    },
  },
  {
    id: 413,
    name: {
      tr: "Antalya Villa Kiralama",
      en: "Antalya Villa Rental",
      de: "Antalya Villenvermietung",
      ru: "Аренда виллы в Анталье",
    },
    image: "/images/services/antalya_villa_rental.jpg",
    description: {
      tr: "Antalya'da Kemer, Kaş ve Belek bölgelerinde aileniz ile beraber size özel lüks villalarımızda tatil keyfi sizi bekliyor. Özel havuzu, özel bahçesi ve tam donanımlı villalarımızda unutulmaz anlar yaşayabilirsiniz. Dilerseniz transfer hizmeti de sunmaktayız.",
      en: "Enjoy a private holiday in our luxury villas located in Kemer, Kaş, and Belek regions of Antalya with your family. Experience unforgettable moments in our fully equipped villas with private pools and gardens. We also offer transfer services upon request.",
      de: "Genießen Sie einen privaten Urlaub in unseren Luxusvillen in den Regionen Kemer, Kaş und Belek in Antalya mit Ihrer Familie. Erleben Sie unvergessliche Momente in unseren voll ausgestatteten Villen mit privaten Pools und Gärten. Auf Anfrage bieten wir auch Transferdienste an.",
      ru: "Насладитесь частным отдыхом в наших роскошных виллах, расположенных в регионах Кемер, Каш и Белек в Анталье с вашей семьей. Испытайте незабываемые моменты в наших полностью оборудованных виллах с частными бассейнами и садами. По запросу мы также предлагаем услуги трансфера.",
    },
  },
];
